import React, { Suspense, lazy } from "react";
import { Route } from "react-router-dom";
import { filterRoutes } from "../utils/moduleAccessUtils";
import { getItem } from "../utils/localStorageUtils";
import { Backdrop, LogoLoader } from "../components";
const AtsDashboard = lazy(() => import("../pages/Ats/AtsDashboard"));
const Help = lazy(() => import("../pages/Ats/Help/Help"));
const TicketDetail = lazy(
  () => import("../pages/Ats/Help/HelpTabs/TicketDetails/TicketDetails"),
);

const Recruiters = lazy(
  () => import("../pages/NonitMarketing/Recruiters/Recruiters"),
);

const Interview = lazy(
  () => import("../pages/NonitMarketing/Interviews/Interviews"),
);
const Submissions = lazy(
  () => import("../pages/NonitMarketing/Submissions/Submissions"),
);
const Placement = lazy(
  () => import("../pages/NonitMarketing/Placements/Placements"),
);

const CandidatesAddNewCandidate = lazy(
  () => import("../pages/NonitMarketing/Jobs/CandidatesAddNewCandidate"),
);
const Candidates = lazy(
  () => import("../pages/NonitMarketing/Candidates/Candidates"),
);
const JobsBenchsales = lazy(
  () => import("../pages/NonitMarketing/Jobs/JobsBenchsales"),
);
const InnerMainLayoutBs = lazy(
  () => import("../pages/NonitMarketing/_layout/InnerMainLayoutBs"),
);
const BenchSalesDashboard = lazy(
  () => import("../pages/NonitMarketing/BenchSalesDashboard"),
);
const Templates = lazy(
  () => import("../pages/NonitMarketing/Templates/Templates"),
);
const ResumeTemplate = lazy(
  () => import("../pages/NonitMarketing/Templates/TemplateTabs/ResumeTemplate"),
);
const Reports = lazy(() => import("../pages/NonitMarketing/BsReports/Reports"));
const Hotlist = lazy(() => import("../pages/NonitMarketing/Hotlist/Hotlist"));

const NmRoutes = ({ moduleAccess = {}, user = {} }) => {
  console.log({ moduleAccess }, { user });
  const loginUserData = user?.data || {};
  const portal = getItem("portal");
  const role = loginUserData?.role?.type ?? null;
  const userModule = loginUserData?.role?.module ?? null;
  console.log({ userModule });
  console.log("role:", role, "userModule:", userModule, "portal:", portal);

  const nmRouteConfig = [
    {
      path: "/nm/dashboard",
      element: <BenchSalesDashboard />,
      id: "dashboard",
    },

    {
      path: "/nm/non-it-marketing/candidates",
      element: <Candidates />,
      id: "nonitcandidates",
    },

    // {
    //   key: "benchsaleshotlist_hotlist_addcandidates",
    //   path: "bs/benchsales/candidates/add-new-candidate",
    //   type: 1,
    //   children: [
    //     {
    //       key: "benchsaleshotlist_hotlist_addcandidate",
    //       path: "bs/benchsales/candidates/add-new-candidate",
    //       type: 1,
    //       children: [],
    //     },
    //   ],
    // },
    // {
    //   key: "benchsaleshotlist_hotlist_editcandidates",
    //   path: "bs/benchsales/candidates/edit-new-candidate",
    //   type: 1,
    //   children: [
    //     {
    //       key: "benchsaleshotlist_hotlist_editcandidate",
    //       path: "bs/benchsales/candidates/edit-new-candidate",
    //       type: 1,
    //       children: [],
    //     },
    //   ],
    // },
    {
      path: "/nm/non-it-marketing/candidates/add-new-candidate",
      element: <CandidatesAddNewCandidate />,
      id: "nonitcandidates_addcandidate",
    },
    {
      path: "/nm/non-it-marketing/candidates/edit-new-candidate",
      element: <CandidatesAddNewCandidate />,
      id: "nonitcandidates_editcandidate",
    },
    {
      path: "/nm/non-it-marketing/jobs",
      element: <JobsBenchsales />,
      id: "nonitjobs",
    },

    // new added for submissions
    {
      path: "/nm/non-it-marketing/submissions",
      element: <Submissions />,
      id: "nonitsubmissions",
    },
    {
      path: "/nm/non-it-marketing/recruiters",
      element: <Recruiters />,
      id: "nonitrecruiters",
    },
    //new added interview

    {
      path: "/nm/non-it-marketing/interview",
      element: <Interview />,
      id: "nonitinterviews",
    },
    {
      path: "/nm/non-it-marketing/placements",
      element: <Placement />,
      id: "nonitplacements",
    },
    {
      path: "/nm/non-it-marketing/templates",
      element: <Templates />,
      id: "nonittemplates",
    },
    {
      path: "/nm/non-it-marketing/hotlist",
      element: <Hotlist />,
      id: "nonithotlist",
    },
    // {
    //   path: "/bs/benchsales/templates/clientemailtemplate",
    //   element: <ClientEmailTemplate />,
    //   id: "benchsalestemplate_clientemailtemplate",
    // },
    // {
    //   path: "/bs/benchsales/templates/candidateemailtemplate",
    //   element: <CandidateEmailTemplate />,
    //   id: "benchsalestemplate_candidateemailtemplate",
    // },
    {
      path: "/nm/non-it-marketing/templates/resumetemplate",
      element: <ResumeTemplate />,
      id: "nonittemplates_templates",
    },

    { path: "/nm/help", element: <Help />, id: "help" },
    {
      path: "/nm/help/ticket-details",
      element: <TicketDetail />,
      id: "ticket_detail",
    },
    {
      path: "/nm/reports",
      element: <Reports />,
      id: "reports",
    },
  ];

  const accessibleRoutes = filterRoutes({
    routes: nmRouteConfig,
    modules: moduleAccess,
    role,
    accessKey: "nonitmarketing",
    userModule,
    portal,
  });

  console.log(
    "accessibleRoutes:",
    accessibleRoutes.map((r) => r.path),
  );
  console.log("moduleAccess in NmRoutes:", moduleAccess);
  console.log(
    "moduleAccess type:",
    typeof moduleAccess,
    Array.isArray(moduleAccess),
  );
  return (
    <>
      <Route
        element={
          <Suspense
            fallback={
              <Backdrop isOpen={true}>
                <LogoLoader />
              </Backdrop>
            }
          >
            <InnerMainLayoutBs />
          </Suspense>
        }
      >
        {accessibleRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
    </>
  );
};

export default NmRoutes;
